import * as React from "react";
import { PickupPointsContainer } from "./PickupPointsContainer.js";
import { PickupStoresContainer } from "./PickupStoresContainer.js";
import { ShippingMethod } from "../../../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
const SelectedShippingMethodContainer = ({
  selectedShippingMethod,
  hasWarningMessageOnly = false,
  isTitleHidden = false,
  selectedStore,
  onStoreSelect,
  onPickupPointSelect,
  selectedPickupPoint,
  onShippingModalClose
}) => {
  switch (selectedShippingMethod) {
    case ShippingMethod.Pickup:
      return /* @__PURE__ */ React.createElement(
        PickupStoresContainer,
        {
          isTitleHidden,
          hasWarningMessageOnly,
          selectedStore,
          onStoreSelect,
          onShippingModalClose
        }
      );
    case ShippingMethod.PickupPoint:
      return /* @__PURE__ */ React.createElement(
        PickupPointsContainer,
        {
          isTitleHidden,
          hasWarningMessageOnly,
          onPickupPointSelect,
          selectedPickupPoint,
          onShippingModalClose
        }
      );
    default:
      return null;
  }
};
export {
  SelectedShippingMethodContainer
};
//# sourceMappingURL=SelectedShippingMethodContainer.js.map
